import React, { useEffect } from "react";
import PageShell from "../components/PageShell";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page Not Found — Culinera";
    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");
    return () => {
      if (robots) robots.setAttribute("content", "index, follow");
    };
  }, []);

  return (
    <PageShell testid="not-found-page">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <p className="text-7xl font-bold text-teal-600 mb-4">404</p>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">We couldn't find that page</h1>
        <p className="text-lg text-gray-600 mb-8">
          The page you're looking for may have moved or never existed. Here are a few good places to start instead.
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          <a href="/" data-testid="notfound-home-link" className="bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors">Go to the homepage</a>
          <a href="/?view=restaurants" data-testid="notfound-directory-link" className="border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors">Browse the directory</a>
          <a href="/blog" data-testid="notfound-journal-link" className="border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors">Read the Journal</a>
        </div>
      </div>
    </PageShell>
  );
}
